import { GroupOutlined, HowToRegOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const StateRequirementLegend = () => (
  <Box sx={{ display: 'flex', gap: 3, mt: 2, px: 1 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <GroupOutlined fontSize="small" color="action" />
      <Typography variant="body2" color="text.secondary">
        Collaboration agreement required
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <HowToRegOutlined fontSize="small" color="success" />
      <Typography variant="body2" color="text.secondary">
        Independent practice available
      </Typography>
    </Box>
  </Box>
);
